import { render, staticRenderFns } from "./member-signup.vue?vue&type=template&id=0f4d7f66&"
import script from "./member-signup.vue?vue&type=script&lang=js&"
export * from "./member-signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports